module.exports = __webpack_public_path__ + "static/media/d9ru.c80fc7c3.pdf";